/**
 * Checks val is object (not array). Most reliable way
 *
 * @param {any} value
 * @returns {Boolean}
 */
export const isObject = (value) => Object.prototype.toString.call(value) === '[object Object]'

/**
 * Checks n is a integer number
 *
 * @type {number} value
 * @returns {Boolean}
 */
export const isInteger = Number.isInteger || ((value) => ((value << 0) === value)) // eslint-disable-line
